/**
 * Returns true if the app is running in production
 * Returns false for preview URLs, QA branches, staging, and local development.
 *
 * Useful for features that only work on registered domains (e.g., Smarty address validation)
 * or for logging that should only occur in stable environments.
 */
export function isProductionEnvironment(): boolean {
  return process.env.PUBLIC_HR_ENV === 'production';
}
